import { useDialog } from "~/src/modules/ui-kit";

import Finder from "../../../../../modules/finder";
import Button from "../../../components/Button";
import SearchBait from "../../../components/SearchBait";
import useSearchKeybind from "../../../components/useSearchKeybind";
import SharedParameterAttributes from "../components/SharedParameterAttributes";
import * as revitParameterTemplateSearch from "../search";


export default function SharedParameterConfiguration(props) {
    const { definition, onChange } = props;

    const [Dialog, open, close] = useDialog();
    useSearchKeybind(open);

    function onSelect(_, __, entity) {
        const { group, instance, modifiable, type, visible } = entity.revitSharedParameterDefinition;
        onChange({ group, instance, modifiable, type, visible });
        close();
    }

    function onAttributeChange(field, value) {
        onChange(
            {
                ...definition,
                [field]: value,
            }
        );
    }

    const disabled = [
        definition?.instance === undefined,
        definition?.modifiable === undefined,
        definition?.visible === undefined,
        definition?.group === undefined,
        Number.isNaN(definition?.group),
        definition?.type === undefined,
        Number.isNaN(definition?.type),
    ].some(Boolean);

    return (
        <>
            <SearchBait>
                <span>you can copy attributes from another revit parameter</span>
                <input
                    onFocus={ open }
                    placeholder="Search"
                />
                <span>find revit parameter</span>
                <span>press <i>/</i> or start typing to search</span>
            </SearchBait>
            <Dialog>
                <Finder
                    modules={ [revitParameterTemplateSearch] }
                    onSelect={ onSelect }
                    placeholder="Search"
                />
            </Dialog>
            <SharedParameterAttributes
                { ...definition }
                setGroup={ (value) => onAttributeChange("group", value) }
                setInstance={ (value) => onAttributeChange("instance", value) }
                setModifiable={ (value) => onAttributeChange("modifiable", value) }
                setType={ (value) => onAttributeChange("type", value) }
                setVisible={ (value) => onAttributeChange("visible", value) }
            />
            <footer>
                <Button onClick={ props.prev }>back</Button>
                <Button disabled={ disabled } onClick={ props.next }>continue</Button>
            </footer>
        </>
    );
}
